<template>
    <div class="ui centered grid">
        <div class="two wide column"></div>
        <div class="twelve wide column">
            <div class="aspect-ratio">
                
               <iframe title="Spanelsky sal 2021" frameborder="0" allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true" allow="autoplay; fullscreen; xr-spatial-tracking" xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share src="https://sketchfab.com/models/c0fd5a36bfc943da87eb07ddc7fd1d2a/embed"> </iframe>
            </div>
        </div>

        <div class="two wide column"></div>
    </div>
</template>

<script>
    export default {
        name: 'visualisation3d',
        data() {
            return {}
        },

        components: {

        },
    }
</script>

<style scoped>
    P {
        text-align: justify;
    }

    .aspect-ratio {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 51%;
    }

    .aspect-ratio iframe {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/router/visualisation3d.vue